module.exports = __webpack_public_path__ + "static/media/antiDamage.ce5ebb27.jpg";